import { AccessLevel, IAccessLevel } from './access-levels.model';
import {
  CheckinProcessConfiguration,
  ICheckinProcessConfiguration
} from './checkin-process-configuration.model';
import { ITurnstile } from './turnstile.model';

export interface ITrainingCenterConfiguration {
  id: string;
  geminiSiteId: string;
  accessLevels: IAccessLevel[];
  turnstiles: ITurnstile[];
  checkinProcessConfiguration: ICheckinProcessConfiguration;
}

export class TrainingCenterConfiguration
implements ITrainingCenterConfiguration {
  id: string;
  geminiSiteId: string;
  accessLevels: AccessLevel[];
  turnstiles: ITurnstile[];
  checkinProcessConfiguration: CheckinProcessConfiguration;

  constructor(clone: TrainingCenterConfiguration = null) {
    this.id = '';
    this.geminiSiteId = '';
    this.accessLevels = [];
    this.turnstiles = [];
    this.checkinProcessConfiguration = new CheckinProcessConfiguration();

    if (clone) {
      this.id = clone.id;
      this.geminiSiteId = clone.geminiSiteId;
      this.accessLevels = clone.accessLevels;
      this.turnstiles = clone.turnstiles;
      this.checkinProcessConfiguration = clone.checkinProcessConfiguration;
    }
  }
}
